import { BLOCK_TYPES, slideshowBlocks, slideshowContent } from '../blocks/schema.js';
import { normalizeSlideshowSettings, plainTextLength } from './settings.js';

/** The page as SlideshowText draws it: its slideshow blocks, and content that follows them. */
export function slideshowTextPage(page) {
    const blocks = slideshowBlocks(page);
    return { ...(page || {}), blocks, content: slideshowContent(blocks) };
}

/** True when the slideshow has any text or vector to show. */
export function slideshowHasText(page) {
    return slideshowBlocks(page).some((block) => (
        block.type === BLOCK_TYPES.VECTOR
        || (block.type === BLOCK_TYPES.RICHTEXT && String(block.html || '').trim() !== '')
    ));
}

/** Plain-text length of all the slideshow's text, for the intro rule. */
export function slideshowTextLength(page) {
    return slideshowBlocks(page)
        .filter((block) => block.type === BLOCK_TYPES.RICHTEXT)
        .reduce((sum, block) => sum + plainTextLength(block.html), 0);
}

/**
 * Wrap the inside of each p, li and heading in span.highlight so the backdrop
 * follows every line of text (box-decoration-break), not the block's box.
 * Display only: the editor edits the stored HTML.
 */
export function wrapTextBlocksInHighlight(html) {
    if (!html || typeof html !== 'string') return html;
    return html
        .replace(/<(p|li|h[1-6])(\s[^>]*)?>/gi, (match, tag, rest = '') => `<${tag}${rest}><span class="highlight">`)
        .replace(/<\/(p|li|h[1-6])>/gi, (match, tag) => `</span></${tag}>`);
}

export const TEXT_SLIDE_ID = '__editorial_text__';

/**
 * Put the text slide among the image slides: first, last, or (slot null) not at all.
 * @param {Array} imageSlides
 * @param {string|null} page - page path, for the first slide's URL
 * @param {boolean} hasText
 * @param {'first'|'last'|null} slot
 */
export function withTextSlide(imageSlides, page, hasText, slot) {
    if (!hasText || !slot) return imageSlides;
    if (slot === 'last') {
        // No URL of its own: the address stays on the last image, so a reload
        // or a shared link never opens on the closing text.
        return [...imageSlides, { id: TEXT_SLIDE_ID, type: 'text' }];
    }
    return [{ id: TEXT_SLIDE_ID, type: 'text', url: page ? `/${page}` : '/' }, ...imageSlides];
}

export function slideshowSettingsOf(page) {
    return normalizeSlideshowSettings(page?.slideshow);
}
